import { render, staticRenderFns } from "./add-files-modal.vue?vue&type=template&id=7e0187af"
import script from "./add-files-modal.ts?vue&type=script&lang=ts&external"
export * from "./add-files-modal.ts?vue&type=script&lang=ts&external"
import style0 from "./add-files-modal.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e0187af')) {
      api.createRecord('7e0187af', component.options)
    } else {
      api.reload('7e0187af', component.options)
    }
    module.hot.accept("./add-files-modal.vue?vue&type=template&id=7e0187af", function () {
      api.rerender('7e0187af', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-input/add-files-modal/add-files-modal.vue"
export default component.exports